import React, { useEffect, useState } from 'react'
import CustomAddPage from '../../../components/CustomComponents/CustomAddPage'

import { useTrainingCategory } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategory'
import { isArray, uploadFilesToAws } from '../../../shared/constants'
import { booleanOptions } from '../../../utils/otherHelper'
import { toastMessage } from '../../../shared/AlertPopup'

export default function AddTrainingCategory({ trainingCategory }) {
  const [trainingCategoryData, setTrainingCategoryData] = useState({
    name: '',
    description: '',
    image: '',
    retestFrequency: '',
    minimumPercentage: '',
    active: true,
    inductionCategory: false,
  })

  const { addTrainingCategory, loading, updateTrainingCategory } = useTrainingCategory()

  const handleTrainingCategory = async () => {
    const image = trainingCategoryData.image
    let location = image
    console.log(image)

    if (!isArray(image)) {
      location = await uploadFilesToAws(image)
    }
    console.log({ location })
    if (trainingCategory) {
      updateTrainingCategory({ ...trainingCategoryData, trainingCategoryId: trainingCategory._id, image: location[0] })
    } else {
      addTrainingCategory({ ...trainingCategoryData, image: !location ? '' : location[0] })
    }
  }

  useEffect(() => {
    if (trainingCategory) {
      setTrainingCategoryData({ ...trainingCategory, image: [trainingCategory.image] })
    }
  }, [trainingCategory])

  const data = [
    { label: 'Training Category Name', value: trainingCategoryData.name, name: 'name' },
    { label: 'Minimum Percentage (%)', value: trainingCategoryData.minimumPercentage, name: 'minimumPercentage', type: 'NUMBER' },
    { label: 'Retest Frequency (Days)', value: trainingCategoryData.retestFrequency, name: 'retestFrequency', type: 'NUMBER' },
    { label: 'Thumbnail', value: trainingCategoryData.image, name: 'image', type: 'IMAGE' },
    { label: 'Induction Category', value: trainingCategoryData.inductionCategory, name: 'inductionCategory', options: booleanOptions, fieldName: 'label', fieldValue: 'value', noValidate: true },
    { label: 'Status', value: trainingCategoryData.active, type: 'ACTIVE' },
    { label: 'Description', value: trainingCategoryData.description, name: 'description', grid: 12 },
  ]

  return (
    <CustomAddPage
      heading="Training Category"
      redirect="ALL_TRAININGCATEGORY"
      currentData={trainingCategory}
      loading={loading}
      state={trainingCategoryData}
      setState={setTrainingCategoryData}
      handleClick={handleTrainingCategory}
      inputFields={data}
    />
  )
}
